import React from "react";

const Bigcard = ( {data} ) => {
    
    return(
        <div className="flex flex-col relative md:p-5 p-2 rounded-3xl lg:gap-56 md:gap-52 gap-32 bg-no-repeat bg-cover bg-top" 
                style={{backgroundImage: `url("${data.bigcard.bg}")`}}
            >
            <div className="absolute inset-0  opacity-60 rounded-3xl" style={{ backgroundColor: data.bigcard.bg_color }}></div>

            <button className="flex secondary-custom-return-button items-center justify-center relative group border-solid rounded-full md:w-12 md:h-12 w-8 h-8 z-10 " 
                    onClick={ () => window.location.replace('/') }
                >
                <img className="absolute p-2.5 transition-opacity duration-500 ease-linear opacity-100 group-hover:opacity-0" 
                    src={data.bigcard.arrow_black} alt="arrow"
                />
                <img className="absolute p-2.5 transition-opacity duration-500 ease-linear opacity-0 group-hover:opacity-100 rotate-180" 
                    src={data.bigcard.arrow_white} alt="arrow"
                />
            </button>

            <span className="md:pr-10 md:px-0 px-2 md:text-left text-center leading-tight font-medium z-10 lg:text-[80px] md:text-[48px] text-[36px] md:text-balance tetx-pretty" 
                style={{color: data.bigcard.title_color}}>{data.bigcard.title}
            </span>

            <div className="flex md:flex-row flex-col justify-between md:items-end items-center md:gap-5 gap-4 z-10 ">
                <div className="flex flex-col md:px-0 px-2 font-medium lg:text-[28px] md:text-[24px] text-[20px] md:text-left text-center 
                        md:w-[60%] text-balance gap-10 leading-tight" 
                        style={{color: data.bigcard.description_color}}
                    >
                        {
                            data.bigcard.description.map(( description, index ) => (
                                <span className="flex">
                                    {description.text}
                                </span>
                            ))
                        }
                </div>
                <button className="flex items-center gap-11 px-9 py-4 w-fit text-nowrap red-custom-button rounded-full" 
                        onClick={() => window.location.replace(data.bigcard.button_url_source)}
                    >
                    <span className="font-medium md:text-[20px] text-[18px]" style={{color: data.bigcard.button_txt_color}}>
                        {data.bigcard.button_txt}
                    </span>
                    <img src={data.bigcard.arrow_white} alt="?"/>
                </button>
            </div>
        </div>
    );
};
export default Bigcard;